import React from "react";
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import moment from "moment";

export const YearlyGraph = (props) => {
  // console.log(props);
  let curr_year = new Date().getFullYear();
  let subset = [];

  let year1 = [];
  let year2 = [];
  let year3 = [];
  let year4 = [];

  for (let i in props.data) {
    if (props.data[i]["date"].split("-")[0] === (curr_year - 3).toString()) {
      let date = new Date(props.data[i]["dte"]);
      date = date.setFullYear(2010);
      subset.push(date);
      subset.push(props.data[i]["final_price"]);
      year1.push(subset);
      subset = [];
    } else if (
      props.data[i]["date"].split("-")[0] === (curr_year - 2).toString()
    ) {
      let date = new Date(props.data[i]["dte"]);
      date = date.setFullYear(2010);
      subset.push(date);
      subset.push(props.data[i]["final_price"]);

      year2.push(subset);
      subset = [];
    } else if (
      props.data[i]["date"].split("-")[0] === (curr_year - 1).toString()
    ) {
      let date = new Date(props.data[i]["dte"]);
      date = date.setFullYear(2010);
      subset.push(date);
      subset.push(props.data[i]["final_price"]);

      year3.push(subset);
      subset = [];
    } else if (props.data[i]["date"].split("-")[0] === curr_year.toString()) {
      let date = new Date(props.data[i]["dte"]);
      date = date.setFullYear(2010);
      subset.push(date);
      subset.push(props.data[i]["final_price"]);
      year4.push(subset);
      subset = [];
    }
  }
  const options = {
    series: [
      {
        data: year1,
        name: "2019",
        color: "#0066ff",
      },
      {
        data: year2,
        name: "2020",
        color: "#c61aff",
      },
      {
        data: year3,
        name: "2021",
        color: "#2eb82e",
      },
      {
        data: year4,
        name: "2022",
        color: "#ffcc00",
      },
    ],
    title: {
      text: "Yearly Price Comparison",
      style: {
        fontWeight: "bold",
        fontSize: "22px",
        color: "#000",
      },
    },
    subtitle: {
      text: props.crop + " " + props.market,
      style: {
        fontWeight: "bold",
        fontSize: "13px",
        color: "#000",
      },
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: false,
    },
    yAxis: {
      title: {
        text: "Prices (INR Quintals)",
      },
    },
    tooltip: {
      formatter: function () {
        return (
          moment(new Date(this.x)).subtract(1, "dates").format("DD") +
          " " +
          moment(new Date(this.x)).subtract(0, "months").format("MMM") +
          " " +
          this.series.name +
          "</b> : <b>" +
          this.y +
          "</b>"
        );
      },
    },
    xAxis: {
      type: "datetime",
      lineWidth: 1,
      lineColor: "#515151",
      tickColor: "#515151",
      tickInterval: 1 * 30 * 24 * 3600 * 1000,
      labels: {
        useHTML: true,
        style: {
          fontSize: "10px",
          padding: "10px",
        },
        formatter: function () {
          return moment(new Date(this.value))
            .subtract(0, "months")
            .format("MMM");
        },
      },
    },
  };
  return <HighchartsReact highcharts={Highcharts} options={options} />;
};
